exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".upload-media-remove-icon {\n  font-size: 12px;\n  color: red;\n  cursor: pointer;\n  position: absolute;\n  top: -5px;\n  right: 25px;\n}", ""]);

// exports
